import React from 'react'

export default function ModalFooter ({
  children
}) {
  return (
    <footer>
      { children }
    </footer>
  )
}
